import React from 'react';
import { motion } from 'framer-motion';
export function FooterSection() {
  return <footer className="w-full bg-forest py-32 px-6 flex flex-col items-center justify-center text-cream" data-id="element-60">
      <motion.div initial={{
      opacity: 0,
      scale: 0.85
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 1.5,
      ease: [0.2, 0.65, 0.3, 0.9]
    }} className="w-full max-w-2xl mb-16" data-id="element-61">
        <img src="https://cdn.magicpatterns.com/uploads/vEZmUYWeeMJzqWvRht4QDT/The_botanical_gallery_Logo_sin_fondo.png" alt="The Botanical Gallery Logo" className="w-full h-auto object-contain" data-id="element-62" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 1.2,
      delay: 0.3,
      ease: [0.2, 0.65, 0.3, 0.9]
    }} className="flex flex-col items-center space-y-6 text-sm md:text-base tracking-widest uppercase opacity-70 text-center" data-id="element-63">
        <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-8" data-id="element-64">
          <a href="#" className="hover:opacity-100 transition-opacity duration-300" data-id="element-65">
            @thebotanicalgallery
          </a>
          <a href="mailto:hola@thebotanicalgallery.com" className="hover:opacity-100 transition-opacity duration-300" data-id="element-66">
            hola@thebotanicalgallery.com
          </a>
        </div>

        <div className="flex flex-col items-center space-y-2 pt-8 border-t border-cream/20 w-full max-w-lg" data-id="element-67">
          <p data-id="element-68">Calle de las Flores 42, Col. Roma Norte, CDMX</p>
          <p className="text-xs opacity-80" data-id="element-69">
            Lunes a Sábado: 9:00 AM – 7:00 PM | Domingo: 10:00 AM – 3:00 PM
          </p>
        </div>

        <p className="pt-8 text-xs opacity-50" data-id="element-70">
          &copy; {new Date().getFullYear()} The Botanical Gallery. Todos los
          derechos reservados.
        </p>
      </motion.div>
    </footer>;
}